import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'regenerator-runtime/runtime'
import "@/assets/css/font.css";
import "@/assets/css/styles.css";
import VueI18n from "vue-i18n";
import VueHtml2Canvas from "vue-html2canvas";
import VueMeta from "vue-meta";
import VueGtag from "vue-gtag";

import vuetify from "@/plugins/vuetify";
import VueClipboard from "vue-clipboard2";
import VueSocialSharing from "vue-social-sharing";
import ChartJsPluginDataLabels from "chartjs-plugin-datalabels";
Vue.use(VueI18n);
Vue.use(require("vue-moment"));
Vue.use(VueClipboard);
Vue.use(VueHtml2Canvas);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.use(VueSocialSharing);
Vue.use(
  VueGtag,
  {
    config: { id: "UA-157539818-1" },
  },
  router
);

import th from "./locales/th_TH";
import en from "./locales/en_US";

const i18n = new VueI18n({
  //construction a new VueI18n
  locale: store.state.locale,
  fallbackLocale: "th", //always displays English if Thai translation is not available
  messages: {
    //'locales' directory contains all the translations in the form of json files
    en: en,
    th: th,
  },
});

// Set i18n as global method
Vue.prototype._i18n = i18n;

// Vue.use(Vuetify);
Vue.config.productionTip = false;

export default new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
  components: {
    ChartJsPluginDataLabels,
  },
}).$mount("#app");
